import React, { useState } from "react";
import AdvanceMenuContext from '../../contexts/advance-menu-context';
import AdvanceMenu from "../../components/AdvanceMenu";
import MainContent from "../../components/MainContent";
import MainLayout from "../../layouts/MainLayout";
import EventForm from "../../components/EventForm";

const Main = () => {
    const [showMenu, setShowMenu] = useState(false);
    const defaultValue = { showMenu, setShowMenu };

    return (
        <AdvanceMenuContext.Provider value={defaultValue}>
            <MainLayout>
                <MainContent></MainContent>
                <AdvanceMenuContext.Consumer>
                    {(context) => (<AdvanceMenu open={context.showMenu} onClose={() => setShowMenu(false)}>
                        <EventForm/>
                    </AdvanceMenu>)}
                </AdvanceMenuContext.Consumer>
            </MainLayout>
        </AdvanceMenuContext.Provider>
    );
};

export default Main;
